webpackJsonp([41],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_DIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CHANGE_CUR_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CHANGE_LOGIN_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return BIND_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CHANGE_BOTTOM_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return UPDATE_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return UPDATE_SERVER_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CHANGE_ALERT_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return UPDATE_CONFIRM_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CHANGE_INDEX_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CHANGE_RECOMMEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CHANGE_BANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CHANGE_LASTEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CHANGE_TOPIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CHANGE_TOP_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CHANGE_CATEGORY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CHANGE_CUR_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return AJAX_UPDATE_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CHANGE_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CHANGE_LIVESTOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPDATE_IS_FAVOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CHANGE_ORDER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return AJAX_UPDATE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CHANGE_ORDER_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return AJAX_ORDER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return AJAX_ORDER_DETAIL_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return INIT_CARTS; });
/* unused harmony export AJAX_UPDATE_CARTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return AJAX_DELETE_CARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return AJAX_CHANGE_GOODS_NUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return AJAX_CHECK_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UNCHECK_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_CARTS_NUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CHANGE_SETTLEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return UPDATE_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return INIT_CASHIER; });
/* unused harmony export UPDATE_CASHIER_PRICES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AJAX_DEL_CARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return INIT_PACKAGE_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AJAX_UPDATE_PACKAGE_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return INIT_PACKAGE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AJAX_UPDATE_PACKAGE_CARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return INIT_PACKAGE_LOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AJAX_UPDATE_PACKAGE_LOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return INIT_PACKAGE_LOG_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return AJAX_PACKAGE_REDUCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return AJAX_PACKAGE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return AJAX_CANCEL_PACKAGE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return INIT_EDIT_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CHANGE_SEARCH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return AJAX_UPDATE_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CHANGE_ARTICLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return AJAX_ARTICLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CHANGE_ARTICLE_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return INIT_FARMER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return AJAX_UPDATE_FARMER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return INIT_FARMER_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return INIT_STANDARD_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return AJAX_UPDATE_STANDARD_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return INIT_STANDARD_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return INIT_ACTIVITY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INIT_RECIPE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AJAX_UPDATE_RECIPE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INIT_RECIPE_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_EVENTS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return INIT_DISCOVER_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CHANGE_CUR_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CHANGE_ADDRESS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return AJAX_CHANGE_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return AJAX_DEL_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CHANGE_MEMBER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CHANGE_COUPON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return AJAX_CHANGE_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CHANGE_RECHARGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return AJAX_UPDATE_RECHARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CHANGE_MY_FAVOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CHANGE_MY_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return AJAX_UPDATE_FAVOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return AJAX_DEL_FAVOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return AJAX_CHANGE_MOBILE; });

var UPDATE_LOADING = 'common/update_loading';

var UPDATE_DIRECTION = 'common/update_direction';

var CHANGE_CUR_TAB = 'common/change_cur_tab';

var CHANGE_LOGIN_INFO = 'common/change_login_info';

var BIND_USER = 'common/bind_user';

var CHANGE_BOTTOM_STATUS = 'common/change_bottom_status';

var UPDATE_POSITION = 'common/update_position';

var UPDATE_SERVER_TIME = 'common/update_server_time';

var CHANGE_ALERT_TITLE = 'common/change_alert_title';

var UPDATE_CONFIRM_CONTENT = 'common/update_confirm_content';

var CHANGE_INDEX_GOODS = 'site/changeIndexGoods';

var CHANGE_RECOMMEND = 'site/changeRecommend';

var CHANGE_BANNER = 'site/changeBanner';

var CHANGE_LASTEST = 'site/changeLastest';

var CHANGE_TOPIC = 'site/topic';

var CHANGE_TOP_CATEGORIES = 'category/change_top_categories';

var CHANGE_CATEGORY_LIST = 'category/change_category_list';

var CHANGE_CUR_GOODS = 'category/change_cur_goods';

var AJAX_UPDATE_GOODS = 'category/ajax_updaye_goods';

var CHANGE_GOODS = 'goods/change_goods';

var CHANGE_LIVESTOCK = 'goods/change_livestock';

var UPDATE_IS_FAVOR = 'goods/update_is_favor';

var CHANGE_ORDER_LIST = 'order/change_order_list';

var AJAX_UPDATE_LIST = 'order/ajax_update_list';

var CHANGE_ORDER_DETAIL = 'order/change_order_detail';

var AJAX_ORDER_STATUS = 'order/ajax_order_status';

var AJAX_ORDER_DETAIL_STATUS = 'order/ajax_order_detail_status';

var INIT_CARTS = 'carts/init_carts';

var AJAX_UPDATE_CARTS = 'carts/ajax_update_carts';

var AJAX_DELETE_CARTS = 'carts/ajax_delete_carts';

var AJAX_CHANGE_GOODS_NUM = 'carts/ajax_change_goods_num';

var AJAX_CHECK_GOODS = 'carts/ajax_check_goods';

var UNCHECK_ALL = 'carts/uncheck_all';

var UPDATE_CARTS_NUM = 'carts/update_carts_num';

var CHANGE_SETTLEMENT = 'settlement/change_settlement';

var UPDATE_PRICES = 'settlement/update_price';

var INIT_CASHIER = 'cashier/init_cashier';

var UPDATE_CASHIER_PRICES = 'cashier/update_cashier_prices';

var AJAX_DEL_CARTS = 'package/ajax_del_carts';

var INIT_PACKAGE_GOODS = 'package/init_package_goods';

var AJAX_UPDATE_PACKAGE_GOODS = 'package/ajax_update_list';

var INIT_PACKAGE_INFO = 'package/init_package_info';

var AJAX_UPDATE_PACKAGE_CARTS = 'package/ajax_update_package_carts';

var INIT_PACKAGE_LOGS = 'package/init_package_logs';

var AJAX_UPDATE_PACKAGE_LOGS = 'package/ajax_update_package_logs';

var INIT_PACKAGE_LOG_DETAIL = 'package/init_package_log_detail';

var AJAX_PACKAGE_REDUCE = 'package/ajax_package_reduce';

var AJAX_PACKAGE_ADD = 'package/ajax_package_add';

var AJAX_CANCEL_PACKAGE_ORDER = 'package/ajax_cancel_package_order';

var INIT_EDIT_PACKAGE = 'package/init_edit_package';

var CHANGE_SEARCH_LIST = 'search/change_search_list';

var AJAX_UPDATE_SEARCH = 'search/ajax_update_search';

var CHANGE_ARTICLE_LIST = 'article/change_article_list';

var AJAX_ARTICLE_LIST = 'article/ajax_article_list';

var CHANGE_ARTICLE_DETAIL = 'article/change_article_detail';

var INIT_FARMER_LIST = 'farmer/init_farmer_list';

var AJAX_UPDATE_FARMER_LIST = 'famer/ajax_update_farmer_list';

var INIT_FARMER_DETAIL = 'farmer/init_farmer_detail';

var INIT_STANDARD_LIST = 'standard/init_standard_list';

var AJAX_UPDATE_STANDARD_LIST = 'standard/ajax_update_standard_list';

var INIT_STANDARD_DETAIL = 'standard/init_standard_detail';

var INIT_ACTIVITY_DETAIL = 'activity/INIT_ACTIVITY_DETAIL';

var INIT_RECIPE_LIST = 'recipe/init_recipe_list';

var AJAX_UPDATE_RECIPE_LIST = 'recipe/ajax_update_recipe_list';

var INIT_RECIPE_DETAIL = 'recipe/init_recipe_detail';

var UPDATE_EVENTS_LIST = 'events/update_events_list';

var INIT_DISCOVER_INDEX = 'discover/init_discover_index';

var CHANGE_CUR_ADDRESS = 'member/change_cur_address';

var CHANGE_ADDRESS_LIST = 'member/change_address_list';

var AJAX_CHANGE_ADDRESS = 'member/ajax_change_address';

var AJAX_DEL_ADDRESS = 'member/ajax_del_address';

var CHANGE_MEMBER_INFO = 'member/change_member_info';

var CHANGE_COUPON_LIST = 'member/change_coupon_list';

var AJAX_CHANGE_COUPON = 'member/ajax_change_coupon';

var CHANGE_RECHARGE_LIST = 'member/change_recharge_list';

var AJAX_UPDATE_RECHARGE = 'member/ajax_update_recharge';

var CHANGE_MY_FAVOR = 'member/change_my_favor';

var CHANGE_MY_PACKAGE = 'member/change_my_package';

var AJAX_UPDATE_FAVOR = 'member/ajax_update_favor';

var AJAX_DEL_FAVOR = 'member/ajax_del_favor';

var AJAX_CHANGE_MOBILE = 'member/ajax_change_mobile';

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export deepCopy */
/* unused harmony export forEachValue */
/* unused harmony export isObject */
/* unused harmony export isPromise */
/* unused harmony export assert */
/* harmony export (immutable) */ __webpack_exports__["c"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = post;
/* harmony export (immutable) */ __webpack_exports__["h"] = rsAlert;
/* harmony export (immutable) */ __webpack_exports__["m"] = rsConfirm;
/* harmony export (immutable) */ __webpack_exports__["j"] = throttle;
/* harmony export (immutable) */ __webpack_exports__["f"] = getQueryString;
/* harmony export (immutable) */ __webpack_exports__["k"] = validate;
/* harmony export (immutable) */ __webpack_exports__["p"] = timeToStr;
/* harmony export (immutable) */ __webpack_exports__["n"] = getWxConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = directRightUrl;
/* unused harmony export unique */
/* harmony export (immutable) */ __webpack_exports__["l"] = recordSearch;
/* harmony export (immutable) */ __webpack_exports__["d"] = isAndroid;
/* harmony export (immutable) */ __webpack_exports__["e"] = isWeiXin;
/* harmony export (immutable) */ __webpack_exports__["o"] = pushHistory;
/* harmony export (immutable) */ __webpack_exports__["g"] = wxConfigCalBack;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__image__ = __webpack_require__(81);
/* unused harmony reexport ESA_IMAGE_PROCESSES */
/* unused harmony reexport esaImageProcess */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__image__["a"]; });






function find(list, f) {
  return list.filter(f)[0];
}

function deepCopy(obj) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
    return obj;
  }

  var hit = find(cache, function (c) {
    return c.original === obj;
  });
  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {};

  cache.push({
    original: obj,
    copy: copy
  });

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

function forEachValue(obj, fn) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object';
}

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function assert(condition, msg) {
  if (!condition) throw new Error('[vuex] ' + msg);
}

function get(url, data, callback, errCallback) {
  callback = callback || function (response) {};

  errCallback = errCallback || function (response) {};

  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.http.get("https://api.yw0511.com/" + url, {
    params: data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'token': __WEBPACK_IMPORTED_MODULE_3__vuex_index__["a" /* default */].state.common.token
    }
  }).then(function (response) {
    return callback(response);
  }).catch(function (response) {
    return errCallback(response);
  });
}

function post(url, data, callback, errCallback) {
  callback = callback || function (response) {};

  errCallback = errCallback || function (response) {};

  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.http.post("https://api.yw0511.com/" + url, data, {
    emulateJSON: true,
    headers: {
      'token': __WEBPACK_IMPORTED_MODULE_3__vuex_index__["a" /* default */].state.common.token
    }
  }).then(function (response) {
    return callback(response);
  }).catch(function (response) {
    return errCallback(response);
  });
}

function rsAlert(title, content, hide, show) {
  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.$vux.alert.show({
    title: title,
    content: content,
    onShow: function onShow() {
      show = show || function () {
        console.log('alert show');
      };
      show();
    },
    onHide: function onHide() {
      hide = hide || function () {
        console.log('alert hide');
      };
      hide();
    }
  });
}

function rsConfirm(title, content, confirmText, cancelText, confirm, cancel) {
  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.$vux.confirm.show({
    'title': title,
    'content': content,
    'confirm-text': confirmText,
    'cancel-text': cancelText,
    onConfirm: function onConfirm() {
      confirm = confirm || function () {
        console.log('confirm show');
      };
      confirm();
    },
    onCancel: function onCancel() {
      cancel = cancel || function () {
        console.log('confirm hide');
      };
      cancel();
    }
  });
}

function throttle(fn, wait, mustRun) {
  var timeout = void 0;
  var startTime = new Date();
  return function () {
    var context = this;
    var args = arguments;
    var curTime = new Date();

    clearTimeout(timeout);

    if (curTime - startTime >= mustRun) {
      fn.apply(context, args);
      startTime = curTime;
    } else {
      timeout = setTimeout(fn, wait);
    }
  };
}

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

function validate(str, type) {
  var reg = void 0;

  switch (type) {
    case 1:
      reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
      break;
    case 2:
      reg = /^1[3|4|5|7|8|9][0-9]\d{4,8}$/;
      break;
    case 3:
      reg = /^((010|02\d{1}|0[3-9]\d{2})-)?\d{7,9}(-\d+)?$/;
      break;
    case 4:
      reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      break;
  }

  return reg.test(str);
}

function timeToStr(timestamp, format) {
  var time = new Date(timestamp * 1000);
  var date = {
    "M+": time.getMonth() + 1,
    "d+": time.getDate(),
    "h+": time.getHours(),
    "m+": time.getMinutes(),
    "s+": time.getSeconds(),
    "q+": Math.floor((time.getMonth() + 3) / 3),
    "S": time.getMilliseconds() };

  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
    }
  }
  return format;
}

function getWxConfig(arr) {
  var wx = __WEBPACK_IMPORTED_MODULE_2_vue___default.a.wechat;
  var href = window.location.href;

  get('v1/misc/wechat_config', {
    href: href
  }, function (rsp) {
    var res = rsp.body;
    if (res.code == 10000) {
      var wxConfig = res.data;
      wx.config({
        debug: false,
        appId: wxConfig.appId,
        timestamp: wxConfig.timestamp,
        nonceStr: wxConfig.nonceStr,
        signature: wxConfig.signature,
        jsApiList: arr
      });
    }
  });
}

function directRightUrl() {
  var _window$location = window.location,
      href = _window$location.href,
      protocol = _window$location.protocol,
      host = _window$location.host,
      search = _window$location.search,
      hash = _window$location.hash;

  var pathname = '/m/';
  search = search || '?';
  hash = hash || '#/';
  var newHref = protocol + '//' + host + pathname + search + hash;
  if (newHref !== href) {
    window.location.replace(newHref);
  }
}

function unique(arr) {
  var result = [];
  var hash = {};
  for (var i = 0, elem; (elem = arr[i]) != null; i++) {
    if (!hash[elem]) {
      result.push(elem);
      hash[elem] = true;
    }
  }
  return result;
}

function recordSearch(str) {
  var logStr = window.sessionStorage.getItem('searchLog');
  var arr = [];

  if (logStr) {
    arr = logStr.split(',');

    if (arr.length >= 10) {
      arr[0] = str;
    } else {
      arr.unshift(str);
    }
  } else {
    arr.unshift(str);
  }

  var result = unique(arr).join(',');
  window.sessionStorage.setItem('searchLog', result);
}



function isAndroid() {
  var u = navigator.userAgent;
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    return true;
  }
  return false;
}

function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  }
  return false;
}

function pushHistory(objs) {
  var state = {
    title: objs.title,
    url: objs.url
  };

  window.history.pushState(state, '', objs.url);
}

function wxConfigCalBack(arr, callback) {
  var wx = __WEBPACK_IMPORTED_MODULE_2_vue___default.a.wechat;
  var href = window.location.href;

  get('v1/misc/wechat_config', {
    href: href
  }, function (rsp) {
    var res = rsp.body;
    if (res.code == 10000) {
      var wxConfig = res.data;
      wx.config({
        debug: false,
        appId: wxConfig.appId,
        timestamp: wxConfig.timestamp,
        nonceStr: wxConfig.nonceStr,
        signature: wxConfig.signature,
        jsApiList: arr
      });

      wx.ready(function () {
        callback();
      });
    }
  });
}

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_site__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_category__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_goods__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_carts__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_farmer__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_member__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_standards__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_activity__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_settlement__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_order__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_recharge__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_group__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_discover__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_search__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_cashier__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_article__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_package__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_rscipe__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_events__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_other__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_about__ = __webpack_require__(85);



























__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    modules: {
        common: __WEBPACK_IMPORTED_MODULE_4__modules_common__["a" /* default */],
        site: __WEBPACK_IMPORTED_MODULE_5__modules_site__["a" /* default */],
        category: __WEBPACK_IMPORTED_MODULE_6__modules_category__["a" /* default */],
        goods: __WEBPACK_IMPORTED_MODULE_7__modules_goods__["a" /* default */],
        carts: __WEBPACK_IMPORTED_MODULE_8__modules_carts__["a" /* default */],
        farmer: __WEBPACK_IMPORTED_MODULE_9__modules_farmer__["a" /* default */],
        member: __WEBPACK_IMPORTED_MODULE_10__modules_member__["a" /* default */],
        standards: __WEBPACK_IMPORTED_MODULE_11__modules_standards__["a" /* default */],
        activity: __WEBPACK_IMPORTED_MODULE_12__modules_activity__["a" /* default */],
        settlement: __WEBPACK_IMPORTED_MODULE_13__modules_settlement__["a" /* default */],
        order: __WEBPACK_IMPORTED_MODULE_14__modules_order__["a" /* default */],
        recharge: __WEBPACK_IMPORTED_MODULE_15__modules_recharge__["a" /* default */],
        group: __WEBPACK_IMPORTED_MODULE_16__modules_group__["a" /* default */],
        discover: __WEBPACK_IMPORTED_MODULE_17__modules_discover__["a" /* default */],
        search: __WEBPACK_IMPORTED_MODULE_18__modules_search__["a" /* default */],
        cashier: __WEBPACK_IMPORTED_MODULE_19__modules_cashier__["a" /* default */],
        article: __WEBPACK_IMPORTED_MODULE_20__modules_article__["a" /* default */],
        packages: __WEBPACK_IMPORTED_MODULE_21__modules_package__["a" /* default */],
        recipe: __WEBPACK_IMPORTED_MODULE_22__modules_rscipe__["a" /* default */],
        events: __WEBPACK_IMPORTED_MODULE_23__modules_events__["a" /* default */],
        other: __WEBPACK_IMPORTED_MODULE_24__modules_other__["a" /* default */],
        about: __WEBPACK_IMPORTED_MODULE_25__modules_about__["a" /* default */]
    }
}));

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(162)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeToNow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return timeToCur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return transTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return timeToDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return timeByRecharge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(6);


var timeToNow = function timeToNow(time) {
    var t = parseFloat(new Date() - new Date(time * 1000)) / 1000;
    var str = void 0;
    if (t) {
        if (t > 60 && t < 3600) {
            str = parseInt(t / 60.0, 10) + '\u5206\u949F\u524D';
        } else if (t >= 3600 && t < 86400) {
            str = parseInt(t / 3600.0, 10) + '\u5C0F\u65F6\u524D';
        } else if (t >= 86400 && t < 86400 * 30) {
            str = parseInt(t / 86400.0, 10) + '\u5929\u524D';
        } else if (t >= 86400 * 30 && t < 86400 * 365) {
            str = parseInt(t / (86400.0 * 30), 10) + '\u4E2A\u6708\u524D';
        } else if (t >= 86400 * 365) {
            str = parseInt(t / (86400.0 * 365), 10) + '\u5E74\u524D';
        } else {
            str = parseInt(t, 10) + '\u79D2\u524D';
        }
    }
    return str;
};

var timeToCur = function timeToCur(timestamp, cur) {
    var t = parseInt(Math.abs(timestamp - cur));
    var str = void 0;

    if (t) {
        if (t > 60 && t < 3600) {
            str = parseInt(t / 60.0, 10) + '\u5206\u949F';
        } else if (t >= 3600 && t < 86400) {
            str = parseInt(t / 3600.0, 10) + '\u5C0F\u65F6';
        } else if (t >= 86400 && t < 86400 * 30) {
            str = parseInt(t / 86400.0, 10) + '\u5929';
        } else if (t >= 86400 * 30 && t < 86400 * 365) {
            str = parseInt(t / (86400.0 * 30), 10) + '\u4E2A\u6708';
        } else if (t >= 86400 * 365) {
            str = parseInt(t / (86400.0 * 365), 10) + '\u5E74';
        } else {
            str = parseInt(t, 10) + '\u79D2';
        }
    }
    return str;
};

var getValue = function getValue(cur, types, key, value) {
    for (var i in types) {
        if (types[i][key] == cur) {
            return types[i][value];
        }
    }
};

var transTime = function transTime(timestamp, format) {
    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* timeToStr */])(timestamp, format);
    return result;
};

var timeToDay = function timeToDay(timestamp, curTime) {
    var time = new Date(timestamp * 1000);
    var t = parseInt(Math.abs(timestamp - curTime));
    var weekday = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    var str = void 0;

    if (t) {
        if (t < 86400) {
            str = '今天';
        } else {
            str = weekday[time.getDay()];
        }
    }

    return str;
};

var timeByRecharge = function timeByRecharge(timestamp, curTime) {
    var t = parseInt(Math.abs(timestamp - curTime));
    var str = void 0;

    if (t) {
        if (t < 86400) {
            str = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* timeToStr */])(timestamp, 'hh:mm');
        } else {
            str = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* timeToStr */])(timestamp, 'MM-dd');
        }
    }

    return str;
};

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
var routes = [{
  path: '/',
  name: 'Home',
  component: function component(resolve) {
    __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(215)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/goods/:id',
  name: 'Goods',
  component: function component(resolve) {
    __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(213)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/classify/:id/:subid',
  component: function component(resolve) {
    __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(208)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/activity/:id',
  name: 'Activity',
  component: function component(resolve) {
    __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(200)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/cart',
  name: 'Cart',
  component: function component(resolve) {
    __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(206)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/settlement/:id',
  name: 'Settlement',
  component: function component(resolve) {
    __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(231)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/cashier_desk/:sn',
  name: 'CahierDesk',
  component: function component(resolve) {
    __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(207)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/product_list/:index',
  name: 'ProductList',
  component: function component(resolve) {
    __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(227)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/address/:id',
  name: 'Address',
  component: function component(resolve) {
    __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(201)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/add_address',
  name: 'AddAddress',
  component: function component(resolve) {
    __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(76)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/edit_address/:id',
  name: 'EditAddress',
  component: function component(resolve) {
    __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(76)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mine',
  name: 'Mine',
  component: function component(resolve) {
    __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(216)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/:type',
  name: 'MyOrder',
  component: function component(resolve) {
    __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order_detail/:sn',
  name: 'OrderDetail',
  component: function component(resolve) {
    __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/balance/:tab',
  name: 'Balance',
  component: function component(resolve) {
    __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(204)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/card_buy',
  name: 'CardBuy',
  component: function component(resolve) {
    __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(205)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/my_coupon/:id',
  name: 'MyCoupon',
  component: function component(resolve) {
    __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(218)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/my_package/:type',
  name: 'MyPackage',
  component: function component(resolve) {
    __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(220)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/package/:id',
  name: 'PackageDetail',
  component: function component(resolve) {
    __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(224)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/package_goods/:nav_id/:address_id',
  name: 'PackageGoods',
  component: function component(resolve) {
    __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(78)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/edit_package/:order_id/:address_id',
  name: 'EditPackage',
  component: function component(resolve) {
    __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(78)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/package_address/:id',
  name: 'PackageAddress',
  component: function component(resolve) {
    __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(223)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/package_logs/:id',
  name: 'PackageLogs',
  component: function component(resolve) {
    __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(226)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/package_log_detail/:id',
  name: 'PackageLogDetail',
  component: function component(resolve) {
    __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(225)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/setting',
  name: 'Setting',
  component: function component(resolve) {
    __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(230)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/my_favor/:type',
  name: 'MyFavor',
  component: function component(resolve) {
    __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(219)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/group_purchase/:type',
  name: 'GroupPurchase',
  component: function component(resolve) {
    __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(214)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/discover',
  name: 'Discover',
  component: function component(resolve) {
    __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(209)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/search',
  name: 'NoSearch',
  component: function component(resolve) {
    __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(80)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/search/:kw',
  name: 'Search',
  component: function component(resolve) {
    __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(80)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/login',
  name: 'Login',
  component: function component(resolve) {
    __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(77)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/register',
  name: 'Register',
  component: function component(resolve) {
    __webpack_require__.e/* require */(3/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(77)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/password',
  name: 'Password',
  component: function component(resolve) {
    __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(79)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/set_password/:type',
  name: 'SetPassword',
  component: function component(resolve) {
    __webpack_require__.e/* require */(4/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(79)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mobile',
  name: 'Mobile',
  component: function component(resolve) {
    __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(217)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/article/:cat_id',
  name: 'ArticleList',
  component: function component(resolve) {
    __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(202)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/article_detail/:id',
  name: 'ArticleDetail',
  component: function component(resolve) {
    __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(203)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/farmers',
  name: 'Farmers',
  component: function component(resolve) {
    __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(212)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/farmer/:id',
  name: 'Farmer',
  component: function component(resolve) {
    __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(211)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/standards/:id',
  name: 'Standards',
  component: function component(resolve) {
    __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(233)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/standard/:id/:sub_id',
  name: 'Standard',
  component: function component(resolve) {
    __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(232)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/recipes',
  name: 'Recipes',
  component: function component(resolve) {
    __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(229)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/recipe/:id',
  name: 'Recipe',
  component: function component(resolve) {
    __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(228)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/events/:id',
  name: 'Events',
  component: function component(resolve) {
    __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(210)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/about',
  name: 'About',
  component: function component(resolve) {
    __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(199)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '*',
  redirect: '/'
}];

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(164)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(176),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(181),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(173),
  /* scopeId */
  "data-v-09d8d59d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ESA_IMAGE_PROCESSES */
/* unused harmony export esaImageProcess */
/* harmony export (immutable) */ __webpack_exports__["a"] = esaImageUrl;

var ESA_IMAGE_PROCESSES = {
  '1000x400': 'resize,w_1000',
  '100x100': 'resize,s_100',
  '1200': 'resize,w_1200',
  '1200x460': 'resize,w_1200',
  '1200x800': 'resize,w_1200',
  '150x150': 'resize,s_150',
  '200x200': 'resize,s_200',
  '224x150': 'resize,w_224',
  '300x185': 'resize,w_300',
  '300x300': 'resize,s_300',
  '380x200': 'resize,w_380',
  '380x230': 'resize,w_380',
  '400x153': 'resize,w_400',
  '400x192': 'resize,w_400',
  '400x400': 'resize,s_400',
  '450': 'resize,w_450',
  '650x435': 'resize,w_650',
  '700': 'resize,w_700',
  '72x72': 'resize,s_72',
  '800': 'resize,w_800',
  '900': 'resize,w_900',
  '900x600': 'resize,w_900',
  'avatar': 'resize,s_200',
  'avatar100': 'resize,s_100',
  'banner': 'resize,w_1200',
  'h120': 'resize,h_120'
};

function esaImageProcess(style) {
  var imageStyle = String(style || '').trim();
  if (!imageStyle) {
    return '';
  }
  if (ESA_IMAGE_PROCESSES[imageStyle]) {
    return ESA_IMAGE_PROCESSES[imageStyle];
  }

  var size = /^(\d+)x(\d+)$/.exec(imageStyle);
  if (size) {
    var width = parseInt(size[1], 10);
    var height = parseInt(size[2], 10);
    if (width < 1 || height < 1) {
      return '';
    }
    return width === height ? 'resize,s_' + width : 'resize,w_' + width;
  }

  var widthOnly = /^(\d+)$/.exec(imageStyle);
  if (widthOnly && parseInt(widthOnly[1], 10) > 0) {
    return 'resize,w_' + parseInt(widthOnly[1], 10);
  }

  var heightOnly = /^h(\d+)$/.exec(imageStyle);
  if (heightOnly && parseInt(heightOnly[1], 10) > 0) {
    return 'resize,h_' + parseInt(heightOnly[1], 10);
  }
  return '';
}

function esaImageUrl(url, style) {
  if (!url || !style) {
    return url;
  }

  var imageUrl = String(url);
  if (/(?:\?|&)image_process=/.test(imageUrl)) {
    return imageUrl;
  }

  var process = esaImageProcess(style);
  if (!process) {
    return imageUrl;
  }

  var fragment = '';
  var fragmentPosition = imageUrl.indexOf('#');
  if (fragmentPosition !== -1) {
    fragment = imageUrl.substring(fragmentPosition);
    imageUrl = imageUrl.substring(0, fragmentPosition);
  }

  var separator = imageUrl.indexOf('?') === -1 ? '?' : '&';
  return '' + imageUrl + separator + 'image_process=' + process + fragment;
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_alert_index_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_confirm_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_plugins_wechat_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_types_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_index__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__App__);

















__webpack_require__(61);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_alert_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_confirm_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vux_src_plugins_wechat_index_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('timeToNow', __WEBPACK_IMPORTED_MODULE_11__filters__["a" /* timeToNow */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('getValue', __WEBPACK_IMPORTED_MODULE_11__filters__["b" /* getValue */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('transTime', __WEBPACK_IMPORTED_MODULE_11__filters__["c" /* transTime */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('timeToCur', __WEBPACK_IMPORTED_MODULE_11__filters__["d" /* timeToCur */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('timeToDay', __WEBPACK_IMPORTED_MODULE_11__filters__["e" /* timeToDay */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('timeByRecharge', __WEBPACK_IMPORTED_MODULE_11__filters__["f" /* timeByRecharge */]);

__WEBPACK_IMPORTED_MODULE_1_fastclick___default.a.attach(document.body);

var history = window.sessionStorage;
history.clear();
var historyCount = history.getItem('count') * 1 || 0;
history.setItem('/', 0);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  base: __dirname,
  routes: __WEBPACK_IMPORTED_MODULE_10__router_index__["a" /* routes */]
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_4__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types_js__["a" /* UPDATE_LOADING */], true);

  var toIndex = history.getItem(to.path);
  var fromIndex = history.getItem(from.path);

  if (toIndex) {
    if (toIndex > fromIndex || !fromIndex || toIndex === '0' && fromIndex === '0') {
      __WEBPACK_IMPORTED_MODULE_4__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types_js__["b" /* UPDATE_DIRECTION */], 'forward');
    } else {
      __WEBPACK_IMPORTED_MODULE_4__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types_js__["b" /* UPDATE_DIRECTION */], 'reverse');
    }
  } else {
    ++historyCount;
    history.setItem('count', historyCount);
    to.path !== '/' && history.setItem(to.path, historyCount);
    __WEBPACK_IMPORTED_MODULE_4__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types_js__["b" /* UPDATE_DIRECTION */], 'forward');
  }

  next();
});

router.afterEach(function (to) {
  __WEBPACK_IMPORTED_MODULE_4__vuex_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types_js__["a" /* UPDATE_LOADING */], false);

  if (true) {
    _hmt.push(['_trackPageview', to.fullPath]);
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app-box',
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_index__["a" /* default */],
  router: router,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_13__App___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLoadingStatus", function() { return changeLoadingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeDirection", function() { return changeDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeCurTab", function() { return changeCurTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserInfo", function() { return getUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCarts", function() { return updateCarts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alertAction", function() { return alertAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmAction", function() { return confirmAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(6);
var _this2 = this;




var changeLoadingStatus = function changeLoadingStatus(_ref, status) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* UPDATE_LOADING */], status);
};

var changeDirection = function changeDirection(_ref2, direction) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* UPDATE_DIRECTION */], direction);
};

var changeCurTab = function changeCurTab(_ref3, curTab) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__types__["_20" /* CHANGE_CUR_TAB */], curTab);
};

var getUserInfo = function getUserInfo(_ref4) {
    var commit = _ref4.commit;

    var token =  true ? localStorage.getItem('RS-TOKEN') : '6:deefb29f-fe58-5903-f9b0-66314ccd2463';

    if (token === null) {
        var code = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* getQueryString */])('code'),
            _state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* getQueryString */])('state'),
            action = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* getQueryString */])('action');

        if (_state == 'wechat_oauth_callback') {
            if (action == 'bind-user') {
                commit(__WEBPACK_IMPORTED_MODULE_0__types__["_19" /* BIND_USER */]);
            } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* post */])('v1/member/weixin_oauth_check', {
                    code: code
                }, function (rsp) {
                    var res = rsp.body;

                    if (res.code == '10000' && typeof res.data.openid != 'undefined') {
                        localStorage.setItem('avatar', res.data.headimgurl);
                        localStorage.setItem('nickname', res.data.nickname);
                        localStorage.setItem('open_id', res.data.openid);
                        localStorage.setItem('union_id', res.data.unionid);

                        location.href = '/m/?state=wechat_oauth_callback&action=bind-user#/';
                    } else if (typeof res.data.token != 'undefined') {
                        localStorage.setItem('RS-TOKEN', res.data.token);
                        commit(__WEBPACK_IMPORTED_MODULE_0__types__["_21" /* CHANGE_LOGIN_INFO */], res.data.token);

                        window.location.href = '/m/?#/';
                    } else {
                        window.location.href = '/m/?#/';
                    }
                });
            }
        } else {
            localStorage.removeItem('RS-TOKEN');

            localStorage.setItem('refHref', location.href);

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* get */])('v1/member/weixin_oauth_url', {}, function (rsp) {
                if (rsp.body.code == '10000') {
                    location.href = rsp.body.data.url;
                } else {
                    location.href = '/m/?#/';
                }
            });
        }
    } else {
        commit(__WEBPACK_IMPORTED_MODULE_0__types__["_21" /* CHANGE_LOGIN_INFO */], token);

        var _this = _this2;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* get */])('v1/member/info', {}, function (rsp) {
            var res = rsp.body;
            if (rsp.body.code != 10000) {
                localStorage.removeItem('RS-TOKEN');

                localStorage.setItem('refHref', location.href);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* get */])('v1/member/weixin_oauth_url', {}, function (rsp) {
                    if (rsp.body.code == '10000') {
                        location.href = rsp.body.data.url;
                    } else {
                        location.href = '/m/?#/';
                    }
                });
            } else {
                localStorage.setItem('RS-TOKEN', token);
            }
        });
    }
};

var updateCarts = function updateCarts(_ref5) {
    var commit = _ref5.commit;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* get */])('v1/cart/lists', {}, function (rsp) {
        var res = rsp.body;
        if (res.code == 10000) {
            commit(__WEBPACK_IMPORTED_MODULE_0__types__["_2" /* INIT_CARTS */], res.data);
        }
    });
};

var alertAction = function alertAction(_ref6, params) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__types__["_25" /* CHANGE_ALERT_TITLE */], params);

    setTimeout(function () {
        params.title = '';
        params.status = false;

        commit(__WEBPACK_IMPORTED_MODULE_0__types__["_25" /* CHANGE_ALERT_TITLE */], params);
    }, 1000);
};

var confirmAction = function confirmAction(_ref7, params) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__types__["_26" /* UPDATE_CONFIRM_CONTENT */], params);
};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goodsStandards", function() { return goodsStandards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classifyFarmers", function() { return classifyFarmers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAddressDetail", function() { return getAddressDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAddressList", function() { return getAddressList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultAddressId", function() { return getDefaultAddressId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCheckedAmount", function() { return getCheckedAmount; });

var goodsStandards = function goodsStandards(state) {
    var arr = [].slice.call(state.standards.list, 0);
    return arr.filter(function (item, index) {
        return [].indexOf.call([1, 2, 3], item.id) != -1;
    });
};

var classifyFarmers = function classifyFarmers(state) {
    var arr = [].slice.call(state.farmer.list, 0);
    return arr.filter(function (item, index) {
        return [].indexOf.call(state.category.farmerIds, item.id) != -1;
    });
};

var getAddressDetail = function getAddressDetail(state) {
    var arr = [].slice.call(state.member.addressList, 0);
    var result = [];

    if (arr.length > 0) {
        result = arr.filter(function (item, index) {
            return item.id == state.member.curAddressId;
        });
    }

    return result.length > 0 ? result[0] : {};
};

var getAddressList = function getAddressList(state) {
    var arr = ['北京', '重庆', '上海', '天津'];
    var list = ['内蒙古', '广西', '西藏', '新疆', '宁夏'];
    var result = [].slice.call(state.member.addressList, 0);

    result.forEach(function (item) {
        if (arr.indexOf(item.full_district[0]) != -1) {
            item.desc = item.full_district[0] + '\u76F4\u8F96\u5E02' + item.full_district[2] + '\u533A';
        } else if (list.indexOf(item.full_district[0]) != -1) {
            item.desc = item.full_district[0] + '\u81EA\u6CBB\u533A' + item.full_district[1] + '\u5E02' + item.full_district[2] + '\u533A';
        } else {
            item.desc = item.full_district[0] + '\u7701' + item.full_district[1] + '\u5E02' + item.full_district[2] + '\u533A';
        }
    });
    return result;
};

var getDefaultAddressId = function getDefaultAddressId(state) {
    var arr = [];

    if (state.member.addressList.length > 0) {
        arr = state.member.addressList.filter(function (item) {
            return item.isdefault == 1;
        });
    }
    return arr.length > 0 ? arr[0]['id'] : 0;
};

var getCheckedAmount = function getCheckedAmount(state) {
    var money = 0,
        unit_money = 0;

    if (state.packages.carts.length > 0) {
        state.packages.carts.forEach(function (item) {
            unit_money = parseInt(item.unit_price * 100);

            money += parseInt(item.num) * unit_money;
        });
    }

    return money / 100;
};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(0);


var state = {
    thumb: 'https://statics.yw0511.com/web/imgs/about-1.jpg',
    tabs: [{
        id: 1,
        title: '理念'
    }, {
        id: 2,
        title: '许诺'
    }, {
        id: 3,
        title: '特点'
    }],
    content: [[{
        id: 11,
        type: 1,
        content: '原味理念</br>商业 社会 文化'
    }, {
        id: 1,
        type: 2,
        content: '我们的价值不单单是提供真正安全、新鲜的当季当地食材的配送到家服务，我们更是将国外的农业可持续化先进理念和互联网技术落地生根，重构了一个“看得见的区域内”生产者和消费者之间长久信任关系的体系，并努力将其惠及到更多的人和地方！'
    }, {
        id: 2,
        type: 3,
        content: 'https://statics.yw0511.com/web/imgs/idea-1.jpg?v=0x04'
    }, {
        id: 3,
        type: 2,
        content: '我们想要重组消费者和生产者之间看得见的信任关系，连接田野中的农夫和城市里的人们。这是一段共生的过程，存在于泥土和嘴巴之间。'
    }, {
        id: 4,
        type: 3,
        content: 'https://statics.yw0511.com/web/imgs/idea-2.jpg?v=0x04'
    }, {
        id: 5,
        type: 2,
        content: '我们旨在恢复一个生产者和消费者在“看得见”的体系内构建长久的信任关系，生产者为消费者生命担责任，消费者为生产者生活尽义务。'
    }, {
        id: 5,
        type: 3,
        content: 'https://statics.yw0511.com/web/imgs/idea-3.jpg?v=0x04'
    }, {
        id: 6,
        type: 2,
        content: '我们期望国外可持续农业的理念和技术，通过原味生活落地生根；'
    }, {
        id: 7,
        type: 2,
        content: '原味生活生态信任农业模式能扎扎实实的解决一部分人的食品安全问题；'
    }, {
        id: 8,
        type: 2,
        content: '呼吁消费者关注农村和农户，呼吁农户逐步降低和不使用农药及化学物质，恢复田间的生态；'
    }, {
        id: 9,
        type: 2,
        content: '能缩短田间和餐桌之间的落差，让消费者收获美味和人情。'
    }, {
        id: 10,
        type: 3,
        content: 'https://statics.yw0511.com/web/imgs/idea-4.jpg?v=0x04'
    }], [{
        id: 1,
        type: 1,
        content: '有名有姓的蔬菜'
    }, {
        id: 2,
        type: 2,
        content: '在这里，所有的食材都有一个具体的姓名，相同的品种因为管理的不同味道也会迥异，我们对农户和基地保持着较高频率的走访、监督和检测，让食物源头的生产者直接互动。'
    }, {
        id: 3,
        type: 3,
        content: 'https://statics.yw0511.com/web/imgs/promise-1.jpg?v=0x03'
    }, {
        id: 4,
        type: 1,
        content: '本地自然好食'
    }, {
        id: 5,
        type: 2,
        content: '我们推崇“吃在当季、吃在当地、吃在当天”的生活方式，能做到“当天采摘、当天捕捞、当天宰杀、当天到家”，保持食物极致的鲜度，只有本地化供应体系才能实现。'
    }, {
        id: 6,
        type: 3,
        content: 'https://statics.yw0511.com/web/imgs/promise-2.jpg?v=0x03'
    }, {
        id: 7,
        type: 1,
        content: '给食物做身体检查'
    }, {
        id: 8,
        type: 2,
        content: '除草药、杀虫剂、重金属污染物、真菌毒素、兽药、激素及有害微生物等，种种你想也想不透、防也防不住的问题，在专业的第三方检测机构定期抽样检测下都将无所遁形，并实时在平台公布、打印出来发布给每一位需要的消费者；话放在这，就是真的会这么干，专业的检测很贵，但贵不过许下的诺言。认真是很麻烦的，但麻烦之后，担心也就免了。'
    }, {
        id: 9,
        type: 3,
        content: 'https://statics.yw0511.com/web/imgs/promise-3.jpg?v=0x03'
    }, {
        id: 10,
        type: 1,
        content: '当天采摘</br>当天补捞'
    }, {
        id: 11,
        type: 2,
        content: '最早的农户从凌晨1点开始，马不停蹄的分拣、包装、称重、打标签、宰杀、分割、装车、配送，确保到你手上接近极致的鲜度。'
    }, {
        id: 12,
        type: 3,
        content: 'https://statics.yw0511.com/web/imgs/promise-4.jpg?v=0x03'
    }, {
        id: 13,
        type: 1,
        content: '不喜欢就找我'
    }, {
        id: 14,
        type: 2,
        content: '如果你有任何不愉快，请在到货后48小时内联系我们，我们很重视你的心情，也愿意聆听你的意见，做一些改变。'
    }], [{
        id: 1,
        type: 3,
        content: 'http://cdn.yw0511.net/trust_all.jpg'
    }]]
};

var getters = {};

var mutations = {};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);



var state = {
    info: {
        activity: {
            name: ''
        },
        detail: [],
        skus: [],
        thumb: ''
    }
};

var getters = {};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["H" /* INIT_ACTIVITY_DETAIL */], function (state, params) {
    state.info = params;
});

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    list: [],
    detail: {
        article: {
            title: ''
        },
        detail: []
    }
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["t" /* CHANGE_ARTICLE_LIST */], function (state, params) {
    state.list = params;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["u" /* AJAX_ARTICLE_LIST */], function (state, params) {
    state.list = state.list.concat(params);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["v" /* CHANGE_ARTICLE_DETAIL */], function (state, params) {
    state.detail = params;
}), _mutations);

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(6);


var _mutations;




var state = {
  list: [],
  cartsNum: 0,
  checks: [],
  total: 0.00
};

var getters = {};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_2" /* INIT_CARTS */], function (state, params) {
  var money = 0;
  var obj = {};

  var list = params.skus.filter(function (item) {
    return parseInt(item.number) > 0;
  });

  state.list = list;
  state.cartsNum = params.sku_numbers;
  state.checks = [];
  state.total = 0.00;

  if (state.list && state.list.length > 0) {
    state.list.forEach(function (item) {
      obj = {
        sku_id: item.sku_id,
        num: parseInt(item.number),
        unit_price: item._sku_.prom_price != '0.00' ? parseFloat(item._sku_.prom_price) : parseFloat(item._sku_.shop_price)
      };

      state.checks.push(obj);
      money += parseInt(item.prices * 100);
    });
  }

  state.total = money / 100;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_3" /* AJAX_DELETE_CARTS */], function (state, ids) {
  var money = 0;
  var num = 0;

  state.list = state.list.filter(function (val) {
    return ids.indexOf(val.sku_id) == -1;
  });

  state.checks = state.checks.filter(function (item) {
    var valid = ids.indexOf(item.sku_id) != -1;
    if (valid) {
      money += item.num * (item.unit_price * 100);
      num += parseInt(item.num);
    }

    return !valid;
  });

  state.cartsNum = state.cartsNum - num >= 0 ? state.cartsNum - num : 0;

  if (parseInt(state.total) > 0) state.total -= money / 100;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_4" /* AJAX_CHANGE_GOODS_NUM */], function (state, params) {
  var unit_price = 0,
      settlement = 0,
      dir = 0,
      dirNum = 0,
      curPrices = 0,
      item = state.list[params.index];

  curPrices = parseInt(item.prices * 100);
  unit_price = curPrices / parseInt(item.number);
  settlement = unit_price * parseInt(params.num);
  dir = settlement - curPrices;
  dirNum = parseInt(params.num) - parseInt(item.number);

  item.number = params.num;
  item.prices = settlement / 100;

  state.cartsNum += dirNum;

  if (state.checks && state.checks.length > 0) {
    state.checks.forEach(function (val) {
      if (val.sku_id == params.sku_id) {
        val.num = params.num;

        state.total = (state.total * 100 + dir) / 100;
      }
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_5" /* AJAX_CHECK_GOODS */], function (state, arr) {
  state.checks = [];
  var obj = {},
      money = 0;

  if (state.list && state.list.length > 0) {
    state.list.forEach(function (item) {
      if (arr.indexOf(item.sku_id) != -1) {
        obj = {
          sku_id: item.sku_id,
          num: parseInt(item.number),
          unit_price: item._sku_.prom_price != '0.00' ? parseFloat(item._sku_.prom_price) : parseFloat(item._sku_.shop_price)
        };

        state.checks.push(obj);
        money += parseInt(item.prices * 100);
      }
    });
  }

  state.total = money / 100;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_6" /* UNCHECK_ALL */], function (state) {
  state.checks = [];
  state.total = 0.00;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* UPDATE_CARTS_NUM */], function (state, params) {
  if (params.type == 1) {
    state.cartsNum = params.num;
  } else {
    state.cartsNum += params.num;
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);



var state = {
    data: {
        coupons: {
            total: 0
        },
        order: {
            real_amount: 0.00
        }
    }
};

var getters = {};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["w" /* INIT_CASHIER */], function (state, params) {
    state.data = params;
});

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    topData: [{
        id: 1,
        title: '当季蔬菜',
        desc: '有机标准种植的蔬菜，安全新鲜、味道浓郁',
        thumb: 'category/thumbs/cat-1.png',
        more: 'category/more/more1.png'
    }, {
        id: 2,
        title: '当季水果',
        desc: '当天采摘，当天到家，甜的回味自然',
        thumb: 'category/thumbs/cat-2.png',
        more: 'category/more/more2.png'
    }, {
        id: 3,
        title: '散养禽蛋',
        desc: '大面积原粮散养，没有颗粒饲料和激素，味美放心',
        thumb: 'category/thumbs/cat-3.png',
        more: 'category/more/more3.png'
    }, {
        id: 5,
        title: '原粮肉类',
        desc: '超长生长期的原粮喂养，肉香且紧致',
        thumb: 'category/thumbs/cat-5.png',
        more: 'category/more/more4.png'
    }, {
        id: 6,
        title: '粮油副食',
        desc: '可持续化种植方式，本地大米不比五常逊色',
        thumb: 'category/thumbs/cat-6.png',
        more: 'category/more/more5.png'
    }, {
        id: 7,
        title: '野生水产',
        desc: '“日渐稀缺”的自然食材，舌尖上的鲜美',
        thumb: 'category/thumbs/cat-7.png',
        more: 'category/more/more6.png'
    }, {
        id: 8,
        title: '休闲食品',
        desc: '原生态、无添加，入口纯正，好吃地停不下来',
        thumb: 'category/thumbs/cat-8.png',
        more: 'category/more/more7.png'
    }, {
        id: 9,
        title: '安全套餐',
        desc: '更实惠、更方便、更丰富、更速度',
        thumb: 'category/thumbs/cat-9.png',
        more: 'category/more/more8.png'
    }, {
        id: 10,
        title: '苗木农资',
        desc: '庭前屋后，看花开花落，品甜美多汁',
        thumb: 'category/thumbs/cat-10.png',
        more: 'category/more/more9.png'
    }, {
        id: 100,
        title: '优惠推选',
        desc: '每一次折扣，都是想回馈您给予的鼓励',
        thumb: 'category/thumbs/cat-0.jpg',
        more: ''
    }],
    topList: [],
    categoryList: [],
    curGoodsList: [],
    maxPrice: 700,
    farmerIds: [1, 2, 3, 4, 5, 6, 7, 8, 9]
};

var getters = {};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_10" /* CHANGE_TOP_CATEGORIES */], function (state, category) {
    state.topList = category;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_11" /* CHANGE_CATEGORY_LIST */], function (state, list) {
    state.categoryList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_12" /* CHANGE_CUR_GOODS */], function (state, list) {
    state.curGoodsList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_13" /* AJAX_UPDATE_GOODS */], function (state, list) {
    state.curGoodsList = state.curGoodsList.concat(list);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    needBind: false,
    bindParam: {
        phone: '',
        captcha: '',
        code: ''
    },
    token: localStorage.getItem("RS-TOKEN"),
    loading: true,
    direction: 'forward',
    tabButtons: [{
        name: '首页',
        icon: 'icon-shouye',
        url: '/'
    }, {
        name: '优惠',
        icon: 'icon-youhui',
        url: '/discover'
    }, {
        name: '购物车',
        icon: 'icon-gouwuche',
        url: '/cart'
    }, {
        name: '我的',
        icon: 'icon-mine',
        url: '/mine'
    }],
    curTab: 0,
    features: [{
        title: '我的订单',
        url: '/order/0',
        thumbnail: 'feature/my-order.png'
    }, {
        title: '待付款',
        url: '/order/1',
        thumbnail: 'feature/to-pay.png'
    }, {
        title: '待收货',
        url: '/order/4',
        thumbnail: 'feature/to-receive.png'
    }, {
        title: '待评价',
        url: '/order/5',
        thumbnail: 'feature/to-comment.png'
    }, {
        title: '我的套餐',
        url: '/my_package/1',
        thumbnail: 'feature/usually.png'
    }, {
        title: '我喜欢的',
        url: '/my_favor/1',
        thumbnail: 'feature/my-favor.png'
    }, {
        title: '我评论的',
        url: '',
        thumbnail: 'feature/my-comment.png'
    }, {
        title: '充值卡充值',
        url: '/balance/1',
        thumbnail: 'feature/deposit-card.png'
    }],
    discover: [{
        id: 2,
        name: '优惠券'
    }, {
        id: 3,
        name: '充值专区'
    }, {
        id: 5,
        name: '优惠'
    }, {
        id: 6,
        name: '预售'
    }],
    showBottom: false,
    scrollTop: 0,
    serverTime: 0,
    alertTitle: '',
    alertStatus: false,
    confirmStatus: false,
    website: '原味生活',
    website_thumb: 'https://img.yw0511.com/icon-single-0x01.jpg'
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_19" /* BIND_USER */], function (state) {
    state.needBind = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* UPDATE_LOADING */], function (state, status) {
    state.loading = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* UPDATE_DIRECTION */], function (state, direction) {
    state.direction = direction;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_20" /* CHANGE_CUR_TAB */], function (state, curTab) {
    state.curTab = curTab;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_21" /* CHANGE_LOGIN_INFO */], function (state, token) {
    state.token = token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_22" /* CHANGE_BOTTOM_STATUS */], function (state, status) {
    state.showBottom = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_23" /* UPDATE_POSITION */], function (state, position) {
    state.scrollTop = position;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_24" /* UPDATE_SERVER_TIME */], function (state, time) {
    state.serverTime = time;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_25" /* CHANGE_ALERT_TITLE */], function (state, params) {
    state.alertTitle = params.title, state.alertStatus = params.status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_26" /* UPDATE_CONFIRM_CONTENT */], function (state, params) {
    state.confirmStatus = params.status;
}), _mutations);

var getters = {};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);



var state = {
    recipesList: [],
    discount: {
        id: 1,
        title: '优惠推荐',
        thumb: 'event1.jpg',
        goodsList: []
    },
    presale: {
        id: 2,
        title: '好物预售',
        thumb: 'event2.jpg',
        goodsList: []
    }
};

var getters = {};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["z" /* INIT_DISCOVER_INDEX */], function (state, params) {
    state.recipesList = params.recipes;
    state.discount.goodsList = params.discount;
    state.presale.goodsList = params.presale;
});

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);



var state = {
    info: [{
        id: 1,
        title: '优惠推荐',
        desc: '尊重自然的安全农业“看天吃饭”，来之不易！这个栏目除了释放折扣回馈您给予鼓励的同时，也希望您能在良心农遭遇台风、水涝、干旱等极端天气，食材的品相降低但不影响食用的情况下，对这些勤勤恳恳按照原味生活的标准去艰苦劳作的他们给予支持，等到了来年，良心农户也定会记得您的恩情，在此先谢谢了!',
        thumb: 'event1.jpg',
        goodsList: []
    }, {
        id: 2,
        title: '好物预售',
        desc: '',
        thumb: 'event2.jpg',
        goodsList: []
    }, {
        id: 3,
        title: '当季新品',
        desc: '',
        thumb: 'event3.jpg',
        goodsList: []
    }]
};

var getters = {};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* UPDATE_EVENTS_LIST */], function (state, params) {
    state.info.forEach(function (item) {
        if (params.id == item.id) {
            item.goodsList = params.list;
        }
    });
});

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    list: [],
    detail: {}
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["Z" /* INIT_FARMER_LIST */], function (state, arr) {
    state.list = arr;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_0" /* AJAX_UPDATE_FARMER_LIST */], function (state, arr) {
    state.list = state.list.concat(arr);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_1" /* INIT_FARMER_DETAIL */], function (state, params) {
    state.detail = params;
}), _mutations);

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    base: {
        brand: { name: '' },
        spec: '',
        specs: [],
        sku_arr: {}
    },
    proms: '',
    livestock: {},
    parts: [],
    isFavor: 0
};

var getters = {};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_7" /* CHANGE_GOODS */], function (state, data) {
    state.base = data.goods ? data.goods : { 'brand': { 'name': '' } };
    state.base.brand = data.goods.brand ? data.goods.brand : { 'name': '' };
    state.proms = data.goodsProms ? data.goodsProms : '';
    state.isFavor = data.isFavor ? data.isFavor : 0;

    if (state.base.specs != []) {
        for (var i in state.base.specs) {
            state.base.specs[i]['value'] = state.base.specs[i]['value'].split(',');

            if (state.base.specs[i]['style'] == 2) {
                state.base.specs[i]['img'] = state.base.specs[i]['img'].split(',');
            } else if (state.base.specs[i]['style'] == 1) {
                state.base.specs[i]['color'] = state.base.specs[i]['color'].split(',');
            }
        }
    }
    if (state.base.spec && state.base.spec != '') {
        state.base.spec = JSON.parse(state.base.spec);
    } else {
        state.base.spec = [];
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_8" /* CHANGE_LIVESTOCK */], function (state, data) {
    state.livestock = data.livestock ? data.livestock : {};
    state.parts = data.parts ? data.parts : [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_9" /* UPDATE_IS_FAVOR */], function (state, bool) {
    state.isFavor = bool;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(0);


var state = {
    list: [{
        id: 1,
        name: '新疆原味瓜子 饱满香脆',
        thumbnail: 'good.png',
        farmer: '一米市集严选',
        spec: '157g',
        shop_price: '9.72',
        promote_price: '',
        promote_type: '',
        stock: '0'
    }, {
        id: 2,
        name: '原味野生红松子',
        thumbnail: 'good.png',
        farmer: '科科美人',
        spec: '255g',
        shop_price: '68.00',
        promote_price: '54.40',
        promote_type: '新品',
        stock: '123'
    }, {
        id: 3,
        name: '原味夏威夷果仁',
        thumbnail: 'good.png',
        farmer: '蓝袋鼠',
        spec: '160g',
        shop_price: '68.00',
        promote_price: '54.40',
        promote_type: '',
        stock: '123'
    }, {
        id: 3,
        name: '新西兰草饲牛尾段',
        thumbnail: 'good.png',
        farmer: '一米市集严选',
        spec: '500g',
        shop_price: '68.00',
        promote_price: '54.40',
        promote_type: '',
        stock: '123'
    }, {
        id: 4,
        name: '不停妈妈生的五彩蛋',
        thumbnail: 'good.png',
        farmer: '天爱庄园',
        spec: '10个',
        shop_price: '68.00',
        promote_price: '54.40',
        promote_type: '买一送一',
        stock: '123'
    }, {
        id: 5,
        name: '新西兰银鳕 宝贝营养首选',
        thumbnail: 'good.png',
        farmer: ' Ocean Gala',
        spec: '150g',
        shop_price: '96.00',
        promote_price: '86.40',
        promote_type: '买一送一',
        stock: '123'
    }, {
        id: 6,
        name: '山东红红富士',
        thumbnail: 'good.png',
        farmer: '山丘先生',
        spec: '12只',
        shop_price: '60.00',
        promote_price: '54.00',
        promote_type: '',
        stock: '123'
    }],
    status: [{
        id: 1,
        name: '进行中'
    }, {
        id: 2,
        name: '已完成'
    }, {
        id: 3,
        name: '已取消'
    }]
};

var getters = {};

var mutations = {};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    base: {},
    favorList: [],
    packageList: [],
    addressList: [],
    recharge: {
        cards: [{
            id: 1,
            name: '100元充值卡',
            expire_time: '2018-6-20'
        }, {
            id: 2,
            name: '200元充值卡',
            expire_time: '2019-6-21'
        }],
        list: []
    },
    curAddressId: 1,
    couponList: [],
    usualList: []
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["L" /* CHANGE_CUR_ADDRESS */], function (state, curId) {
    state.curAddressId = curId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["M" /* CHANGE_ADDRESS_LIST */], function (state, list) {
    state.addressList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["N" /* AJAX_CHANGE_ADDRESS */], function (state, list) {
    state.addressList = state.addressList.concat(list);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["O" /* AJAX_DEL_ADDRESS */], function (state, id) {
    for (var i in state.addressList) {
        if (state.addressList[i]['id'] == id) {
            state.addressList.splice(i, 1);
        }
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["P" /* CHANGE_MEMBER_INFO */], function (state, data) {
    state.base = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["Q" /* CHANGE_COUPON_LIST */], function (state, list) {
    state.couponList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["R" /* AJAX_CHANGE_COUPON */], function (state, list) {
    state.couponList = state.couponList.concat(list);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["S" /* CHANGE_RECHARGE_LIST */], function (state, list) {
    state.recharge.list = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["T" /* AJAX_UPDATE_RECHARGE */], function (state, list) {
    state.recharge.list = state.recharge.list.concat(list);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["U" /* CHANGE_MY_FAVOR */], function (state, list) {
    state.favorList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["V" /* CHANGE_MY_PACKAGE */], function (state, list) {
    state.packageList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["W" /* AJAX_UPDATE_FAVOR */], function (state, list) {
    state.favorList = state.favorList.concat(list);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["X" /* AJAX_DEL_FAVOR */], function (state, id) {
    for (var i in state.favorList) {
        if (state.favorList[i]['id'] == id) {
            state.favorList.splice(i, 1);
        }
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["Y" /* AJAX_CHANGE_MOBILE */], function (state, mobile) {
    state.base.mobile = mobile;
}), _mutations);

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    list: [],
    detail: {
        _main: {
            _pay_type: '在线支付'
        },
        _status: {
            wait_status: ''
        }
    },
    types: [{
        id: 0,
        title: '全部订单'
    }, {
        id: 1,
        title: '待付款'
    }, {
        id: 3,
        title: '待发货'
    }, {
        id: 4,
        title: '待收货'
    }, {
        id: 5,
        title: '已完成'
    }, {
        id: 8,
        title: '已删除'
    }]
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["A" /* CHANGE_ORDER_LIST */], function (state, list) {
    state.list = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["B" /* AJAX_UPDATE_LIST */], function (state, params) {
    state.list = state.list.concat(params);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["C" /* CHANGE_ORDER_DETAIL */], function (state, params) {
    state.detail = params;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["D" /* AJAX_ORDER_STATUS */], function (state, params) {
    state.list.forEach(function (item) {
        if (item.id == params.spu_id) {
            item.status = params.status;
            if (params.status == 2) {
                item._status.wait_status = '已取消';
            }

            item._subs.forEach(function (sub) {
                sub.status = params.status;

                if (params.status == 2) {
                    sub._status.wait_status = '已取消';
                }
            });
        }
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["E" /* AJAX_ORDER_DETAIL_STATUS */], function (state, params) {
    state.detail.status = params.status;
    if (params.status == 2) {
        state.detail._status.wait_status = '已取消';
    }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(0);


var state = {
  card: {
    thumb: 'card/card1.jpg',
    title: '原味充值卡',
    desc: '食物原本的味道怎能一人独享，独乐乐不如众乐乐，人生分享而加倍快乐，因分享而更有情趣……',
    content: [{
      id: 1,
      type: 3,
      content: 'card/card2.jpg'
    }, {
      id: 2,
      type: 2,
      content: '您可以将这份真情实意亲自赠与挚爱的亲朋，也可以委托我们将这份感动传达给您的至交好友。'
    }, {
      id: 3,
      type: 2,
      content: '这份礼物将会由一个白色的信封承载，上面写着“原味生活、吃在当季、吃在当地、吃在当天”。打开内部折页，你送给对方的这张充值卡被安放在这里。你在原味生活上看到过的优质食材也罗列在目。'
    }, {
      id: 4,
      type: 3,
      content: 'card/card3.jpg'
    }, {
      id: 5,
      type: 3,
      content: 'card/card4.jpg'
    }, {
      id: 6,
      type: 2,
      content: '原味还把我们所坚持的“可持续化农业方式”、“吃在当季、吃在当地、吃在当天”、“构建经过原味筛选、孵化、培养、监督、检测的实名制本地农户和消费者之间长久信任关系”等理念简述与此，收到卡片的人，会立刻明白你这份礼物的分量与意义：“原味，我不仅仅是收到了一张购物充值卡，更重要的，是我一直在寻找的——安全新鲜的食物、保留了食材原本味道的食物，此刻，你帮我找到了”'
    }, {
      id: 7,
      type: 3,
      content: 'card/card5.jpg'
    }, {
      id: 8,
      type: 2,
      content: '接受你这份心意的人，在原味生活使用这张充值卡「购物—付款」的流程会十分简明、便捷。'
    }, {
      id: 9,
      type: 3,
      content: 'card/card6.jpg'
    }, {
      id: 10,
      type: 2,
      content: '与一般购物流程相比，用此卡充值之后，就可在结算时直接用账户余额付款，免去跳转支付方式的步骤，更加方便。'
    }, {
      id: 11,
      type: 2,
      content: '所以，在你把这张好看又好用的充值卡送给他人的同时，也可以考虑，为自己也买上一份。毕竟，你怎样爱他人，也应该怎样爱自己。'
    }]
  }
};

var getters = {};

var mutations = {};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    package: {
        category: [],
        list: [],
        address: {}
    },
    carts: [],
    logs: [],
    logDetail: [],
    other: {
        id: '',
        date: ''
    }
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["h" /* AJAX_DEL_CARTS */], function (state, params) {
    if (state.carts.length == 0) return;

    if (params.clean) {
        state.carts = [];
    } else {
        var filter = state.carts.filter(function (item) {
            return params.id != item.id;
        });
        state.carts = filter;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["i" /* AJAX_UPDATE_PACKAGE_CARTS */], function (state, params) {
    var num = 0;
    state.carts.forEach(function (item) {
        if (item.id == params.id) {
            item.num++;
            num++;
        }
    });

    if (num == 0) {
        state.carts.push(params);
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["j" /* INIT_PACKAGE_GOODS */], function (state, lists) {
    state.package.list = lists;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["k" /* AJAX_UPDATE_PACKAGE_GOODS */], function (state, list) {
    state.package.list = state.package.list.concat(list);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["l" /* INIT_PACKAGE_INFO */], function (state, params) {
    state.package.category = params.category;
    state.package.address = params.address;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["m" /* INIT_PACKAGE_LOGS */], function (state, arr) {
    state.logs = arr;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["n" /* AJAX_UPDATE_PACKAGE_LOGS */], function (state, arr) {
    state.logs = state.logs.concat(arr);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["o" /* INIT_PACKAGE_LOG_DETAIL */], function (state, params) {
    state.logDetail = params;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["p" /* AJAX_PACKAGE_REDUCE */], function (state, id) {
    state.carts.forEach(function (item) {
        if (item.id == id) {
            item.num -= 1;
        }
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["q" /* AJAX_PACKAGE_ADD */], function (state, id) {
    state.carts.forEach(function (item) {
        if (item.id == id) {
            item.num = parseInt(item.num);

            item.num += 1;
        }
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["r" /* AJAX_CANCEL_PACKAGE_ORDER */], function (state, id) {
    var arr = state.logs.filter(function (item) {
        return item.id != id;
    });

    state.logs = arr;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["s" /* INIT_EDIT_PACKAGE */], function (state, params) {
    state.package.address = params.address;
    state.carts = [];
    state.other.id = params.info.p_item_id;
    state.other.date = params.info.p_date;

    if (params.carts.length > 0) {
        params.carts.forEach(function (item) {
            var items = {};
            items.id = item.sku_id;
            items.name = item.sku_name;
            items.num = item.buy_nums;
            items.thumb = item.thumb;
            items.unit_amount = item.unit_amount;
            items.unit_type = item.unit_type;
            items.unit_price = item.package_price;

            state.carts.push(items);
        });
    }
}), _mutations);

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(0);


var state = {
    thumb: 'recharge.jpg',
    content: [{
        id: 1,
        type: 2,
        content: '尝过这一味',
        sort: 0
    }, {
        id: 2,
        type: 2,
        content: '解冻Tips：食用前一晚，将带包装的食材放在10-15℃的室温中解冻；或者冰箱冷藏室0-4℃冷藏解冻，这两种方式均可以保留住食材原本鲜嫩的肉质和营养成分。',
        sort: 1
    }, {
        id: 3,
        type: 3,
        content: 'goods_imgs.png',
        sort: 2
    }, {
        id: 4,
        type: 3,
        content: 'recharge.jpg',
        sort: 3
    }, {
        id: 2,
        type: 2,
        content: '解冻Tips：食用前一晚，将带包装的食材放在10-15℃的室温中解冻；或者冰箱冷藏室0-4℃冷藏解冻，这两种方式均可以保留住食材原本鲜嫩的肉质和营养成分。',
        sort: 4
    }],
    goodsList: [{
        id: 1,
        thumbnail: 'good.png',
        name: '不同妈妈生的五彩蛋',
        promote_action: '',
        shop_price: '50.00',
        promote_price: '49.99',
        count: 2,
        amount: '100.00'
    }, {
        id: 2,
        thumbnail: 'good.png',
        name: '传统老素鸡',
        promote_action: '九折优惠',
        shop_price: '200',
        promote_price: '',
        count: 1,
        amount: '200.00'
    }, {
        id: 13,
        thumbnail: 'good.png',
        name: '不同妈妈生的五彩蛋',
        promote_action: '',
        shop_price: '50.00',
        promote_price: '49.99',
        count: 2,
        amount: '100.00'
    }, {
        id: 14,
        thumbnail: 'good.png',
        name: '传统老素鸡',
        promote_action: '九折优惠',
        shop_price: '200',
        promote_price: '',
        count: 1,
        amount: '200.00'
    }]
};

var getters = {};

var mutations = {};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    list: [],
    detail: {
        recipe: {
            major: '',
            minor: ''
        },
        steps: []
    }
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["e" /* INIT_RECIPE_LIST */], function (state, arr) {
    state.list = arr;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["f" /* AJAX_UPDATE_RECIPE_LIST */], function (state, arr) {
    state.list = state.list.concat(arr);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["g" /* INIT_RECIPE_DETAIL */], function (state, params) {
    state.detail = params;
}), _mutations);

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    list: [],
    hotList: ['野猪杂交黑猪尾巴', '野猪杂交黑猪排骨', '无农药架豆', '河塘野生泥鳅', '无农药秀珍菇', '无农药菜椒', '无农药玉珍果', '无添加白吐司']
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["x" /* CHANGE_SEARCH_LIST */], function (state, list) {
    state.list = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["y" /* AJAX_UPDATE_SEARCH */], function (state, data) {
    state.list = state.list.concat(data);
}), _mutations);

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(0);



var _mutations;



var state = {
    data: {
        carts: {
            skus: [],
            promot_total: 0.00
        },
        tips: {
            isshow: false,
            msg: ''
        }
    },
    final: {
        deliverys_total: 0.00,
        real_amount: 0.00,
        promot_total: 0.00
    }
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["F" /* CHANGE_SETTLEMENT */], function (state, params) {
    state.data = params;
    state.final.deliverys_total = params.carts.deliverys_total;
    state.final.real_amount = params.carts.real_amount;
    state.final.promot_total = params.carts.promot_total;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["G" /* UPDATE_PRICES */], function (state, params) {
    var discount = 0;
    var delivery_fee = 0;
    var middle = state.data.carts;
    var final = state.final;

    for (var i in middle.skus) {
        middle.skus[i]['sku_list'].forEach(function (sku) {
            if (sku._promos.length > 0) {
                var arr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(sku._promos);
                var query = arr.shift();

                switch (query['type']) {
                    case 'number_give':case 'amount_give':
                        break;
                    case 'amount_discount':
                        var amount = parseInt(sku.number * (sku.prices * 100));
                        var number = Math.floor(amount / query['condition'] / 100);

                        discount += parseFloat(query['discount']) * 100 * number;
                        break;
                    case 'number_discount':
                        var num = Math.floor(sku.number / query['condition']);

                        discount += parseFloat(query['discount']) * 100 * num;
                        break;
                }
            }
        });
    }

    for (var key in params) {
        if (params[key]['prom']['type'] == '0') {
            discount += parseInt(params[key]['prom']['discount'] * 100);
        }

        if (params[key]['prom']['type'] == '1') {
            console.log('delivery_empty');
        }
    }

    final.promot_total = (discount / 100).toFixed(2);
    final.deliverys_total = ((parseInt(middle.deliverys_total * 100) - delivery_fee) / 100).toFixed(2);
    final.real_amount = parseInt(middle.all_prices * 100) + parseInt(final.deliverys_total * 100) - parseInt(final.promot_total * 100);
    final.real_amount = (parseInt(final.real_amount) / 100).toFixed(2);
}), _mutations);

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    bannerList: [],
    topClassify: [{
        id: 5,
        thumb: 'classify/classify1.jpg',
        title: '当季新品',
        url: 'events/3'
    }, {
        id: 2,
        thumb: 'classify/classify2.jpg',
        title: '优惠推选',
        url: 'events/1'
    }, {
        id: 3,
        thumb: 'classify/classify3.jpg',
        title: '充值专区',
        url: 'balance/1'
    }, {
        id: 4,
        thumb: 'classify/classify4.jpg',
        title: '我的优惠券',
        url: 'my_coupon/1'
    }],
    activityItems: [],
    activityList: [],
    recommends: {
        name: '当季新品',
        recommendList: []
    },
    categoryGoodsList: []
};

var getters = {};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_14" /* CHANGE_BANNER */], function (state, focus) {
    state.bannerList = focus;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_15" /* CHANGE_TOPIC */], function (state, topic) {
    state.activityItems = topic;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_16" /* CHANGE_RECOMMEND */], function (state, recommendList) {
    state.recommends.recommendList = recommendList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_17" /* CHANGE_INDEX_GOODS */], function (state, goods) {
    state.categoryGoodsList = goods;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["_18" /* CHANGE_LASTEST */], function (state, list) {
    var params = {
        id: 100,
        name: '最新产品',
        img: '',
        skus: []
    };
    params.skus = list;
    state.activityList.push(params);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(0);


var _mutations;



var state = {
    navs: [{
        id: 1,
        name: '无农药',
        thumb: 'standards/1.png'
    }, {
        id: 2,
        name: '野生',
        thumb: 'standards/2.png'
    }, {
        id: 3,
        name: '原生态',
        thumb: 'standards/3.png'
    }, {
        id: 4,
        name: '合理用药',
        thumb: 'standards/4.png'
    }],
    list: [],
    detail: {
        content: []
    }
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["I" /* INIT_STANDARD_LIST */], function (state, list) {
    state.list = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["J" /* AJAX_UPDATE_STANDARD_LIST */], function (state, list) {
    state.list = state.list.concat(list);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["K" /* INIT_STANDARD_DETAIL */], function (state, params) {
    state.detail = params;
}), _mutations);

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(55);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show');
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__badge__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__badge__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tabbar-item',
  components: {
    Badge: __WEBPACK_IMPORTED_MODULE_1__badge___default.a
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(42);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__ = __webpack_require__(118);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_home_rs_bottom__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_home_rs_bottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_home_rs_bottom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(6);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    rsBottom: __WEBPACK_IMPORTED_MODULE_4_components_home_rs_bottom___default.a
  },
  data: function data() {
    return {
      includedComponents: 'home,discover'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    loading: function loading(state) {
      return state.common.loading;
    },
    direction: function direction(state) {
      return state.common.direction;
    },
    showBottom: function showBottom(state) {
      return state.common.showBottom;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getUserInfo'])),
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* directRightUrl */])();
    this.getUserInfo();
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_webpack_zepto__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_webpack_zepto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_webpack_zepto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_item_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_types__ = __webpack_require__(0);


(function () {
  var c = document.createElement('script');
  c.setAttribute('type', 'text/javascript');
  c.setAttribute('async', true);
  c.setAttribute('src', ('https:' == location.protocol ? 'https://' : 'http://') + 'captcha.luosimao.com/static/dist/captcha.js?v=201610101436');
  var x = document.getElementsByTagName('script')[0];
  x.parentNode.insertBefore(c, x);
})();









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tabbar: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_vue___default.a,
    TabbarItem: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_item_vue___default.a
  },
  data: function data() {
    return {
      documentWidth: 0,
      tips: '',
      showTips: false,
      isSending: false,
      sendLabel: '获取短信',
      isBinding: false,
      bindLabel: '<i class="iconfont icon-complete"></i> 提交绑定',
      bindParam: {
        mobile: '',
        code: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    needBind: function needBind(state) {
      return state.common.needBind;
    },
    navs: function navs(state) {
      return state.common.tabButtons;
    },
    curTab: function curTab(state) {
      return state.common.curTab;
    },
    cartsNum: function cartsNum(state) {
      return state.carts.cartsNum;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sendSMS: function sendSMS(e) {
      var _this = this;
      if (!_this.isSending) {

        if (!/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(_this.bindParam.mobile)) {
          _this.showTip('手机号不合法');
          return false;
        }

        _this.isSending = true;
        _this.sendLabel = '发送中...';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["b" /* post */])('v1/member/send_sms', {
          mobile: _this.bindParam.mobile

        }, function (rsp) {
          if (rsp.body.code != 10000) {
            _this.showTip(rsp.body.msg);
            _this.sendLabel = '获取短信';
            _this.isSending = false;
            LUOCAPTCHA.reset();
          } else {
            var seconds = 60;
            var s = setInterval(function () {
              if (seconds > 0) {
                seconds--;
                _this.sendLabel = seconds + 's后重发';
              } else {
                _this.sendLabel = '获取短信';
                _this.isSending = false;
                clearInterval(s);
              }
            }, 1000);
          }
        });
      }
    },
    showTip: function showTip(tip) {
      var _this = this;
      _this.showTips = true;
      _this.tips = tip;
      setTimeout(function () {
        _this.showTips = false;
        _this.tips = '';
      }, 3000);
    },
    bindUser: function bindUser() {
      var _this = this;
      if (!/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(_this.bindParam.mobile)) {
        _this.showTip('手机号不合法');
        return false;
      }
      if (_this.bindParam.code == '') {
        _this.showTip('请输入短信验证码');
        return false;
      }

      var avatar = localStorage.getItem('avatar');
      var nickname = localStorage.getItem('nickname');
      var open_id = localStorage.getItem('open_id');
      var union_id = localStorage.getItem('union_id');

      if (open_id.length > 0 && union_id.length > 0) {
        _this.isBinding = true;
        _this.bindLabel = '<i class="iconfont icon-loading spin"></i> 绑定中';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["b" /* post */])('v1/member/bind_mobile', {
          mobile: _this.bindParam.mobile,
          code: _this.bindParam.code,
          nickname: nickname,
          avatar: avatar,
          union_id: union_id,
          open_id: open_id
        }, function (rsp) {
          _this.isBinding = false;
          _this.bindLabel = '<i class="iconfont icon-complete"></i> 提交绑定';
          if (rsp.body.code == 10000) {

            localStorage.removeItem(avatar);
            localStorage.removeItem(nickname);
            localStorage.removeItem(open_id);
            localStorage.removeItem(union_id);

            localStorage.setItem("RS-TOKEN", rsp.body.data.token);

            var href = localStorage.getItem('refHref');
            href = href != undefined ? href : '/';

            localStorage.removeItem('refHref');
            window.location.href = href;
          } else {
            _this.showTip(rsp.body.msg);
          }
        });
      } else {

        window.location.href = '/';
        return false;
      }
    },
    getCartsNum: function getCartsNum() {
      var _this = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["c" /* get */])('/v1/cart/get_carts_num', {}, function (rsp) {
        var res = rsp.body;
        if (res.code == 10000) {
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__vuex_types__["c" /* UPDATE_CARTS_NUM */], {
            type: 1,
            num: parseInt(res.data)
          });
        }
      });
    },
    getFocus: function getFocus(type, event) {
      var target = event.target,
          index = __WEBPACK_IMPORTED_MODULE_1_webpack_zepto___default()(target).parents('.form-control').index();

      if (type == 1) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["d" /* isAndroid */])() && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["e" /* isWeiXin */])()) {
          __WEBPACK_IMPORTED_MODULE_1_webpack_zepto___default()('.bind-form').css({
            'height': index == 2 ? '100%' : '140%',
            'top': index == 2 ? '-10%' : '-40%'
          });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1_webpack_zepto___default()('.bind-form').css({
          'height': '70%',
          'top': '10%'
        });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['changeCurTab'])),
  mounted: function mounted() {
    this.getCartsNum();
  }
});

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tabbar', {
    staticClass: "rs_bottom"
  }, [(_vm.needBind) ? _c('div', {
    staticClass: "bind-container"
  }, [_c('div', {
    staticClass: "bind-form"
  }, [_c('div', {
    staticClass: "bind-content relative"
  }, [_c('h5', [_vm._v("绑定手机号")]), _vm._v(" "), _c('div', {
    staticClass: "bind-tip",
    style: ({
      'opacity': _vm.showTips ? 1 : '0'
    })
  }, [_c('i', {
    staticClass: "iconfont icon-tishi",
    staticStyle: {
      "font-size": ".8rem!important"
    }
  }), _vm._v(" " + _vm._s(_vm.tips) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bindParam.mobile),
      expression: "bindParam.mobile"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bindParam.mobile)
    },
    on: {
      "focus": function($event) {
        return _vm.getFocus(1, $event)
      },
      "blur": function($event) {
        return _vm.getFocus(2, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bindParam, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("短信验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bindParam.code),
      expression: "bindParam.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bindParam.code)
    },
    on: {
      "focus": function($event) {
        return _vm.getFocus(1, $event)
      },
      "blur": function($event) {
        return _vm.getFocus(2, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bindParam, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send-msg",
    class: {
      'active': _vm.isSending
    },
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "top", undefined, $event.key, undefined)) { return null; }
        return _vm.sendSMS($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.sendLabel))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-bottom"
  }, [_c('button', {
    staticClass: "submit-btn",
    attrs: {
      "disabled": _vm.isBinding ? true : false
    },
    domProps: {
      "innerHTML": _vm._s(_vm.bindLabel)
    },
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "top", undefined, $event.key, undefined)) { return null; }
        return _vm.bindUser.apply(null, arguments)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.navs), function(nav, index) {
    return _c('tabbar-item', {
      attrs: {
        "selected": index == _vm.curTab,
        "link": nav.url,
        "badge": (index == 3) ? _vm.cartsNum.toString() : ''
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeCurTab(index)
        }
      }
    }, [_c('i', {
      class: ['iconfont', 'relative', nav.icon],
      attrs: {
        "slot": "icon"
      },
      slot: "icon"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(nav.name))])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    class: {
      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: (_vm.maskStyle),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.hide.apply(null, arguments)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        return _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        return _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticStyle: {
      "z-index": "100000"
    }
  }, [_c('loading', {
    attrs: {
      "title": "加载中..."
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  })], 1), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "include": _vm.includedComponents
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1), _vm._v(" "), _c('rs-bottom', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBottom),
      expression: "showBottom"
    }],
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tabbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-confirm"
  }, [_c('x-dialog', {
    attrs: {
      "dialog-class": _vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        return _vm.$emit('on-hide')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [(!!_vm.title) ? _c('div', {
    staticClass: "weui-dialog__hd",
    class: {
      'with-no-content': !_vm.showContent
    }
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.showContent) ? [(!_vm.showInput) ? _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    })]
  })], 2) : _c('div', {
    staticClass: "vux-prompt"
  }, [(((_vm.getInputAttrs()).type) === 'checkbox') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.msg) ? _vm._i(_vm.msg, null) > -1 : (_vm.msg)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "change": function($event) {
        var $$a = _vm.msg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.msg = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.msg = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.msg = $$c
        }
      }
    }
  }, 'input', _vm.getInputAttrs(), false)) : (((_vm.getInputAttrs()).type) === 'radio') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.msg, null)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "change": function($event) {
        _vm.msg = null
      }
    }
  }, 'input', _vm.getInputAttrs(), false)) : _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": (_vm.getInputAttrs()).type
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  }, 'input', _vm.getInputAttrs(), false))])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [(_vm.showCancelButton) ? _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]) : _vm._e(), _vm._v(" "), (_vm.showConfirmButton) ? _c('a', {
    staticClass: "weui-dialog__btn",
    class: ("weui-dialog__btn_" + _vm.confirmType),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText || '确定'))]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: ['vux-badge', {
      'vux-badge-dot': typeof _vm.text === 'undefined',
      'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1
    }],
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "weui-tabbar__item",
    class: {
      'weui-bar__item_on': _vm.isActive,
      'vux-tabbar-simple': _vm.simple
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onItemClick(true)
      }
    }
  }, [(!_vm.simple) ? _c('div', {
    staticClass: "weui-tabbar__icon",
    class: [_vm.iconClass || _vm.$parent.iconClass, {
      'vux-reddot': _vm.showDot
    }]
  }, [(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive)) ? _vm._t("icon") : _vm._e(), _vm._v(" "), (!_vm.simple && _vm.hasActiveIcon && _vm.isActive) ? _vm._t("icon-active") : _vm._e(), _vm._v(" "), (_vm.badge) ? _c('sup', [_c('badge', {
    attrs: {
      "text": _vm.badge
    }
  })], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._t("label")], 2)])
},staticRenderFns: []}

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(172),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(163)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(175),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(166)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(179),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(180),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(182),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(165)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(178),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.de43d84.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/add-icon.4ae67a8.png";

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAABMCAYAAAAC5cu6AAAErElEQVR42u2dTUhVQRiGjSREkQrNQjJKRJFALJMIK3BhopALEWvhQoxw4cKUsIWQ5CKhFmJFEYJUhAsRo7BCIiTCjIoSoSixIgor+qH/IrLbNzSXjvfcez0/75wzc5rFu5TzzcO5Z+b9fsaEUCiUoGVfaRsrVpLukUqs/o0G5wz0YtIkKUT6TqrRsMWAXkQa5aCN2qthY0EvIA1EAR3WMdJCDRsDuzsO6LDOk5I1bHegWyyADusWKUPDdgZ6hw3QYT0h5WnY9kCXkn46gM30jrRZw7YGuoD00SHosH6QajXs+KCzSC9cgjaqTYONDnop6T4QNFO/hmsGnUS6DgZ9lZkhDXgu6IWkQTDoCWbv9TfbDLsHDPoZKVOfRsyg28Cg35Py9TnbDLoODPqb8XytYf8DXebCtETTLKla50bMoAsBpiVSTTrrZwa9mjQDBt2l89lm0Gmkh2DQp1m+W8OeCzqZNAYGPcJMi67UmE3LEBj0XVKqrkGaYZ8Ag35KWqGr62bQ7WDQbyKLAxr2X9D1AkzLJrtx/A+gywWYlionsQQddBHpC/itbnQaT5BBZ5Neg0F3uokpqKCXkabAoPvmMy1Q2HaOOT6blnEw6MukRLex2VnEHtJX0lbJTcswGPQdUgoiPqsLMFYwPpDWSgq7Fwx6mn2SUPFZ+UmeixLEc9afLBnoDgGmJQcZ43ybzM04wUyGC5kSgN4lwLQUo+OMFXwu6bGFoK5ZyXYJBl3JjQbStFSKiDVa8CWktzaCG3B7JHIBupi/hci3ukFUvJHB1/CxBbsBdvsAOod/V5GgO0TGbAy+lfTbRaCtHoLO4CcFJOhe0XGHj3ZHQAHv9AB0Cj/7IkEPxxvPQMJGVi5Ydq1UIOhE7uaQoMdjjWWIgN0MDp61BhQIGh7qA8c6hTQtlr7Z9MDD4EWwvuZVYNid4BhZRjDby03d+Nb0gxfzgPU5g0A3gmNjOe4ir09QkcOUV8CLYn3OSS5BV4FNC9tXyv3wBdHGhCfAwAed7vSszifAtNT75XajLTCT9xUjF3jUAeg8Aaal3c/UQqyF5vOxMuRC99kpUvCeDOTzj/udMIu34BIBP+E6C6BTeZcR8rlDXpgWt/nsagGb07Z5bjwYAYMe88q0ICo1TeDFfyKti2FazoCfxTpV02QpcFj9hh4EQ3jJ+qMjntEFfsZM5DNUgc3eulMC3rp0Qb8eljIolK1GavcGGfT39AYfHkLvC2UyFqTtnn1FnBRCXp94lIDNgS/nd2nICLpN5gYip/mKXAHuzq16ZO/WcpMgEpG38Dz/ogRsDnw7eHPzJbOoBGwOfLePoNmdIEtU6a5FVVEO+ACaVYOyVGpllrk+6HmdUwnYhm7XSx6AFlrBVwK2oev1tmDYtapORIgasZgWBLpF5fETlfrwulUGLXSAieBs4GMhCNC+dcoqAZsDryD9cgl61O8ecCVgc+ANLkBLM92gBGwOfL8D0NLN7SgBmwM/aQO0tBNpqsBmpueCxVt5twRx8li26dtZq/8ZQ8O2Bjyd9CgG7OYg3xLh1zjdGtKrCNCHgn73iZ/zi+tJnznos0EwLVJfgcFvubkYFNMyn/4ANhvo5T20wHAAAAAASUVORK5CYII="

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAYAAAAJKR1YAAAABGdBTUEAALGPC/xhBQAAAV9JREFUSA3t1r1KQzEUwPFeO1elu49QCt2kOLi6dPYlHAv2DRwcCg5uvkCnzg5ujr6BSGdxEQRBvf5TmzbEhNx8FsTAaXLPvcn5NU1pW63/ttmBuq73iZ1NZksjEKfEEyHaK3FNdLbCofAFYWp3JKuiKAraMBI4apcSCQy1xo56j0UOVEOMsD6vPzMm9UmcEHvEPTGvqqqmj2oemHcK9ZbFmDQmPgi13XLRjdEw33Vm1HpnEjMk+6XeUcYPjINQzPPBTNZvnIlXCsA09EYFY4SKyTOTQss1RkVhVqCJVtx26URFY1agXRZa2BRa3opKghEg0VhsQLxoxW2Xv1A86HOAz3+qOl5ZNAiVBSOtAagpc5q2ZjsjMbJndZ+dyovJhArbGYmRfaKdSoNJhEqLiUTlwQSi8mI01Jvja1UGo6COAH1aUDfyuaI9mGNC/ZkRf+wuiyJMxUAcEIeme38q9w1R3Yaes/SU9wAAAABJRU5ErkJggg=="

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(65)();
// imports


// module
exports.push([module.i, ".vux-modal-open {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n.vux-modal-open-for-container {\r\n  overflow: hidden!important;\r\n}\r\n", "", {"version":3,"sources":["/root/workspace/__flow_work/__flow_builds/cb933383-c455-4793-a962-5fc79d01142f/workspace/code/Original-Life-Mobile/node_modules/vux/src/styles/vux-modal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,2BAA2B;CAC5B","file":"vux-modal.css","sourcesContent":[".vux-modal-open {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n.vux-modal-open-for-container {\r\n  overflow: hidden!important;\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ })
],[82]);


// WEBPACK FOOTER //
// static/js/app.7f89068d4c4a18dc9ba5.js